"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BackButton", {
  enumerable: true,
  get: function () {
    return _BackButton.BackButton;
  }
});
Object.defineProperty(exports, "CloseButton", {
  enumerable: true,
  get: function () {
    return _CloseButton.CloseButton;
  }
});
Object.defineProperty(exports, "DEFAULT_DIALOG_PADDING", {
  enumerable: true,
  get: function () {
    return _calculateMaxWidth.DEFAULT_DIALOG_PADDING;
  }
});
Object.defineProperty(exports, "Transition", {
  enumerable: true,
  get: function () {
    return _Transition.Transition;
  }
});
Object.defineProperty(exports, "calculateMaxWidth", {
  enumerable: true,
  get: function () {
    return _calculateMaxWidth.calculateMaxWidth;
  }
});
var _calculateMaxWidth = require("./calculateMaxWidth");
var _BackButton = require("./BackButton");
var _CloseButton = require("./CloseButton");
var _Transition = require("./Transition");
//# sourceMappingURL=index.js.map